import { css } from "styled-system/css";

export const containerStyles = css({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  minHeight: "calc(100dvh - 4rem)",
  padding: "xl",
  backgroundColor: "bgBase200",
});

export const contentStyles = css({
  width: "100%",
  maxWidth: "24rem",
  marginInline: "auto",
});

export const titleStyles = css({
  fontFamily: "sans",
  fontWeight: 900,
  letterSpacing: "tight",
  color: "textBase",
  fontSize: "h2",
  textAlign: "center",
  marginBottom: "lg",
});

export const formStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "md",
});

export const fieldStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "xs",
});

export const labelStyles = css({
  fontSize: "sm",
  fontWeight: 700,
  color: "color-mix(in srgb, {colors.textBase}, transparent 40%)",
  paddingInline: "0.25rem",
});

export const inputStyles = css({
  width: "100%",
  padding: "sm",
  borderRadius: "medium",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  backgroundColor: "bgBase100",
  color: "inherit",
  outline: "none",
  _focus: {
    borderColor: "primary",
  },
});

export const buttonStyles = css({
  cursor: "pointer",
  transitionProperty: "all",
  transitionDuration: "0.2s",
  userSelect: "none",
  border: "none",
  outline: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "md",
  padding: "sm",
  backgroundColor: "primary",
  color: "primaryContent",
  borderRadius: "medium",
  fontWeight: 900,
  textTransform: "uppercase",
  letterSpacing: "widest",
});

export const errorStyles = css({
  backgroundColor: "color-mix(in srgb, {colors.error}, transparent 90%)",
  color: "error",
  padding: "sm",
  borderRadius: "medium",
  fontSize: "sm",
  fontWeight: 700,
  marginBottom: "md",
  textAlign: "center",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "color-mix(in srgb, {colors.error}, transparent 80%)",
});

export const footerStyles = css({
  marginTop: "lg",
  textAlign: "center",
});

export const linkStyles = css({
  cursor: "pointer",
  transitionProperty: "all",
  transitionDuration: "0.2s",
  userSelect: "none",
  border: "none",
  outline: "none",
  fontSize: "sm",
  fontWeight: 700,
  color: "primary",
  backgroundColor: "transparent",
  textDecorationLine: "none",
  _hover: {
    textDecorationLine: "underline",
  },
});
